import { gql, useQuery } from '@apollo/client'

export const LIST_COMPLIANCE_CONFIGURATIONS = gql`
  query ListComplianceConfigurations {
    projectComplianceConfigList {
      configs {
        id
        projectId
        categories
        complianceThresholdDays
        outreachGapDays
        maxOutreachAttempts
        createdAt
        updatedAt
      }
    }
  }
`

export const useComplianceConfigurationList = (options = {}) =>
  useQuery(LIST_COMPLIANCE_CONFIGURATIONS, {
    fetchPolicy: 'cache-and-network',
    ...options,
  })
